import { useState } from "react";
import {
  ProcurementsDetailsPageHeader,
  ProcurementsDetails,
  AddTagModal,
} from "./components";

import { useProcurement } from "@hooks/inventory/procurements/useProcurement";

import { ProductType } from "@type/inventory/procurements";
import CreateProcurements from "../CreateProcurements";

const ProcurementDetails = () => {
  const procurementData = useProcurement();
  const [isAddTagOpen, setIsAddTagOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<ProductType>(
    {} as ProductType,
  );

  const onAddTagOpen = (data: ProductType) => {
    setSelectedItem(data);
    setIsAddTagOpen(true);
  };

  const onAddTagClose = () => {
    setIsAddTagOpen(false);
  };

  return (
    <div className="p-10">
      <ProcurementsDetailsPageHeader procurementData={procurementData} />
      <CreateProcurements
        detailsView={true}
        procurementData={procurementData}
      />
      <ProcurementsDetails
        onAddTagOpen={onAddTagOpen}
        procurementData={procurementData}
      />
      {isAddTagOpen && (
        <AddTagModal
          procurementData={procurementData}
          isOpen={isAddTagOpen}
          onClose={onAddTagClose}
          data={selectedItem}
        />
      )}
    </div>
  );
};

export default ProcurementDetails;
